const LINKS = {
  IOS: "https://apps.apple.com/us/app/dotbee-provema/id1491446553",
  ANDROID: "https://play.google.com/store/apps/details?id=com.provema.walletmobiapp1",
};

export default LINKS;
